const countriesAndRegions: any = {
  countries: {
    AF: "Afganistán",
    AX: "Islas Aland",
    AL: "Albania",
    DZ: "Argelia",
    AS: "Samoa Americana",
    AD: "Andorra",
    AO: "Angola",
    AI: "Anguila",
    AQ: "Antártida",
    AG: "Antigua y Barbuda",
    AR: "Argentina",
    AM: "Armenia",
    AW: "Aruba",
    AU: "Australia",
    AT: "Austria",
    AZ: "Azerbaiyán",
    BS: "Bahamas",
    BH: "Bahréin",
    BD: "Bangladés",
    BB: "Barbados",
    BY: "Bielorrusia",
    BE: "Bélgica",
    BZ: "Belice",
    BJ: "Benín",
    BM: "Bermudas",
    BT: "Bután",
    BO: "Bolivia",
    BA: "Bosnia y Herzegovina",
    BW: "Botsuana",
    BV: "Isla Bouvet",
    BR: "Brasil",
    IO: "Territorio Británico del Océano Índico",
    VG: "Islas Vírgenes Británicas",
    BN: "Brunéi",
    BG: "Bulgaria",
    BF: "Burkina Faso",
    BI: "Burundi",
    KH: "Camboya",
    CM: "Camerún",
    CA: "Canadá",
    CV: "Cabo Verde",
    BQ: "Países Bajos del Caribe",
    KY: "Islas Caimán",
    CF: "República Centroafricana",
    TD: "Chad",
    CL: "Chile",
    CN: "China",
    CX: "Isla de Navidad",
    CC: "Islas Cocos (Keeling)",
    CO: "Colombia",
    KM: "Comoras",
    CG: "Congo (Brazzaville)",
    CD: "Congo (Kinshasa)",
    CK: "Islas Cook",
    CR: "Costa Rica",
    HR: "Croacia",
    CU: "Cuba",
    CW: "Curazao",
    CY: "Chipre",
    CZ: "Republica Checa",
    DK: "Dinamarca",
    DJ: "Yibuti",
    DM: "Dominica",
    DO: "República Dominicana",
    EC: "Ecuador",
    EG: "Egipto",
    SV: "El Salvador",
    GQ: "Guinea Ecuatorial",
    ER: "Eritrea",
    EE: "Estonia",
    ET: "Etiopía",
    FK: "Islas Malvinas",
    FO: "Islas Faroe",
    FJ: "Fiyi",
    FI: "Finlandia",
    FR: "Francia",
    GF: "Guayana Francesa",
    PF: "Polinesia francesa",
    TF: "Territorios Franceses del Sur",
    GA: "Gabón",
    GM: "Gambia",
    GE: "Georgia",
    DE: "Alemania",
    GH: "Ghana",
    GI: "Gibraltar",
    GR: "Grecia",
    GL: "Groenlandia",
    GD: "Granada",
    GP: "Guadalupe",
    GU: "Guam",
    GT: "Guatemala",
    GG: "Guernesey",
    GN: "Guinea",
    GW: "Guinea-Bisáu",
    GY: "Guayana",
    HT: "Haití",
    HM: "Islas Heard y McDonald",
    HN: "Honduras",
    HK: "Hong Kong",
    HU: "Hungría",
    IS: "Islandia",
    IN: "India",
    ID: "Indonesia",
    IR: "Irán",
    IQ: "Irak",
    IE: "Irlanda",
    IM: "Isla de Man",
    IL: "Israel",
    IT: "Italia",
    CI: "Costa de Marfil",
    JM: "Jamaica",
    JP: "Japón",
    JE: "Jersey",
    JO: "Jordania",
    KZ: "Kazajstán",
    KE: "Kenia",
    KI: "Kiribati",
    KW: "Kuwait",
    KG: "Kirguistán",
    LA: "Laos",
    LV: "Letonia",
    LB: "Líbano",
    LS: "Lesoto",
    LR: "Liberia",
    LY: "Libia",
    LI: "Liechtenstein",
    LT: "Lituania",
    LU: "Luxemburgo",
    MO: "China MO",
    MK: "Macedonia",
    MG: "Madagascar",
    MW: "Malaui",
    MY: "Malasia",
    MV: "Maldivas",
    ML: "Malí",
    MT: "Malta",
    MH: "Islas Marshall",
    MQ: "Martinica",
    MR: "Mauritania",
    MU: "Mauricio",
    YT: "Mayotte",
    MX: "México",
    FM: "Micronesia",
    MD: "Moldavia",
    MC: "Mónaco",
    MN: "Mongolia",
    ME: "Montenegro",
    MS: "Monserrat",
    MA: "Marruecos",
    MZ: "Mozambique",
    MM: "Birmania",
    NA: "Namibia",
    NR: "Nauru",
    NP: "Nepal",
    NL: "Países Bajos",
    AN: "Antillas Holandesas",
    NC: "Nueva Caledonia",
    NZ: "Nueva Zelanda",
    NI: "Nicaragua",
    NE: "Níger",
    NG: "Nigeria",
    NU: "Niue",
    NF: "Isla Norfolk",
    MP: "Islas Marianas del Norte",
    KP: "Corea del Norte",
    NO: "Noruega",
    OM: "Omán",
    PK: "Pakistán",
    PW: "Palaus",
    PS: "Territorio Palestino",
    PA: "Panamá",
    PG: "Papúa Nueva Guinea",
    PY: "Paraguay",
    PE: "Perú",
    PH: "Filipinas",
    PN: "Pitcairn",
    PL: "Polonia",
    PT: "Portugal",
    PR: "Puerto Rico",
    QA: "Catar",
    RE: "Reunión",
    RO: "Rumania",
    RU: "Rusia",
    RW: "Ruanda",
    BL: "San Bartolomé",
    SH: "Santa Elena",
    KN: "San Cristóbal y Nieves",
    LC: "Santa Lucía",
    MF: "San Martín (parte francesa)",
    PM: "San Pedro y Miquelón",
    VC: "San Vicente y las Granadinas",
    WS: "Samoa",
    SM: "San Marino",
    ST: "Santo Tomé y Príncipe",
    SA: "Arabia Saudita",
    SN: "Senegal",
    RS: "Serbia",
    SC: "Seychelles",
    SL: "Sierra Leona",
    SG: " Singapur",
    SX: "San Martín",
    SK: "Eslovaquia",
    SI: "Eslovenia",
    SB: "Islas Salomón",
    SO: "Somalia",
    ZA: "Sudáfrica",
    GS: "Georgia del Sur y las Islas Sandwich del Sur",
    KR: "Corea del Sur",
    SS: "Sudán del Sur",
    ES: "España",
    LK: "Sri Lanka",
    SD: "Sudán",
    SR: "Surinam",
    SJ: "Svalbard y Jan Mayen",
    SZ: "Suazilandia",
    SE: "Suecia",
    CH: "Suiza",
    SY: "Siria",
    TW: "Taiwán",
    TJ: "Tayikistán",
    TZ: "Tanzania",
    TH: "Tailandia",
    TL: "Timor Oriental",
    TG: "Togo",
    TK: "Tokelau",
    TO: "Tonga",
    TT: "Trinidad y Tobago",
    TN: "Túnez",
    TR: "Turquía",
    TM: "Turkmenistán",
    TC: "Islas Turcos y Caicos",
    TV: "Tuvalu",
    VI: "Islas Vírgenes Norteamericanas",
    UG: "Uganda",
    UA: "Ucrania",
    AE: "Emiratos Árabes Unidos",
    GB: "Reino Unido",
    US: "EE. UU.",
    UM: "Islas ultramarinas menores de los Estados Unidos",
    UY: "Uruguay",
    UZ: "Uzbekistán",
    VU: "Vanuatu",
    VA: "Vaticano",
    VE: "Venezuela",
    VN: "Vietnam",
    WF: "Wallis y Futuna",
    EH: "Sahara Occidental",
    YE: "Yemen",
    ZM: "Zambia",
    ZW: "Zimbabue",
  },
  regions: {
    "123": "Andalucía",
    "124": "Aragón",
    "125": "Asturias",
    "126": "Islas Baleares",
    "127": "País Vasco",
    "128": "Islas Canarias",
    "129": "Cantabria",
    "130": "Castilla y León",
    "131": "Castilla-La Mancha",
    "132": "Cataluña",
    "133": "Ceuta",
    "134": "Extremadura",
    "135": "Galicia",
    "136": "La Rioja (España)",
    "137": "Madrid",
    "138": "Melilla",
    "139": "Murcia",
    "140": "Navarra",
    "141": "Comunidad Valenciana",
    "142": "Ática",
    "143": "Grecia Central",
    "144": "Macedonia Central",
    "145": "Creta",
    "146": "Macedonia Oriental y Tracia",
    "147": "Epiro",
    "148": "Islas Jónicas",
    "149": "Egeo septentrional",
    "150": "Peloponeso",
    "151": "Egeo Meridional",
    "152": "Tesalia",
    "153": "Grecia Occidental",
    "154": "Macedonia Occidental",
    "155": "Aveiro",
    "156": "Beja",
    "157": "Braga",
    "158": "Bragança",
    "159": "Castelo Branco",
    "160": "Coimbra",
    "161": "Évora",
    "162": "Faro",
    "163": "Guarda",
    "164": "Leiria",
    "165": "Lisboa",
    "166": "Portalegre",
    "167": "Oporto",
    "168": "Santarem",
    "169": "Santarém",
    "170": "Viana do Castelo",
    "171": "Vilareal",
    "172": "Viseo",
    "173": "North",
    "174": "Sur",
    "175": "Centro",
    "176": "Islas Andaman y Nicobar",
    "177": "Andhra Pradesh",
    "178": "Arunachal Pradesh",
    "179": "Assam",
    "180": "Bihar",
    "181": "Chandigarh",
    "182": "Chhattisgarh",
    "183": "Dadra and Nagar Haveli",
    "184": "Daman and Diu",
    "185": "Goa",
    "186": "Gujarat",
    "187": "Haryana",
    "188": "Himachal Pradesh",
    "189": "Jammu and Kashmir",
    "190": "Jharkhand",
    "191": "Karnataka",
    "192": "Kerala",
    "193": "Lakshadweep",
    "194": "Madhya Pradesh",
    "195": "Maharashtra",
    "196": "Manipur",
    "197": "Meghalaya",
    "198": "Mizoram",
    "199": "Nagaland",
    "200": "Territorio de la Capital Nacional de Delhi",
    "201": "Odisha",
    "202": "Puducherry",
    "203": "Punjab",
    "204": "Rajasthan",
    "205": "Sikkim",
    "206": "Tamil Nadu",
    "207": "Telangana",
    "208": "Tripura",
    "209": "Uttar Pradesh",
    "210": "Uttarakhand",
    "211": "Bengala Occidental",
    "212": "Nueva Gales del Sur",
    "213": "Queenland",
    "214": "Sur de Australia",
    "215": "Tasmania",
    "216": "Victoria",
    "217": "Australia Occidental",
    "218": "Territorio del Norte",
    "219": "Pacífic Islands",
    "220": "PNG",
    "221": "Adana",
    "222": "Adıyaman",
    "223": "Afyonkarahisar",
    "224": "Ağri",
    "225": "Aksaray",
    "226": "Amasya",
    "227": "Ankara",
    "228": "Antalya",
    "229": "Ardahan",
    "230": "Artvin",
    "231": "Aydın",
    "232": "Balıkesir",
    "233": "Bartın",
    "234": "Batman",
    "235": "Bayburt",
    "236": "Bilecik",
    "237": "Bingöl",
    "238": "Bitlis",
    "239": "Bolu",
    "240": "Burdur",
    "241": "Bursa",
    "242": "Çanakkale",
    "243": "Çankırı",
    "244": "Çorum",
    "245": "Denizli",
    "246": "Diyarbakır",
    "247": "Düzce",
    "248": "Edirne",
    "249": "Elazığ",
    "250": "Erzincan",
    "251": "Erzurum",
    "252": "Eskişehir",
    "253": "Gaziantep",
    "254": "Giresun",
    "255": "Gümüşhane",
    "256": "Hakkari",
    "257": "Hatay",
    "258": "Iğdır",
    "259": "Isparta",
    "260": "Istanbul",
    "261": "Kahramanmaraş",
    "262": "Karabük",
    "264": "Karaman",
    "265": "Kars",
    "266": "Kastamonu",
    "267": "Kayseri",
    "268": "Kilis",
    "269": "Kırıkkale",
    "270": "Kırklareli",
    "271": "Kırşehir",
    "272": "Kocaeli",
    "273": "Konya",
    "274": "Kütahya",
    "275": "Malatya",
    "276": "Manisa",
    "277": "Mardin",
    "278": "Mersin",
    "279": "Muğla",
    "280": "Muş",
    "281": "Nevşehir",
    "282": "Niğde",
    "283": "Ordu",
    "284": "Osmaniye",
    "285": "Rize",
    "286": "Sakarya",
    "287": "Samsun",
    "288": "Şanlıurfa",
    "289": "Siirt",
    "290": "Sinop",
    "291": "Şırnak",
    "292": "Sivas",
    "293": "Tekirdağ",
    "294": "Tokat",
    "295": "Trabzon",
    "296": "Tunceli",
    "297": "Uşak",
    "298": "Van",
    "299": "Yalova",
    "300": "Yozgat",
    "301": "Baja California",
    "302": "Baja California Sur",
    "303": "Chihuahua",
    "304": "Durango",
    "305": "Sinaloa",
    "306": "Sonora",
    "307": "Coahuila",
    "308": "Nuevo",
    "309": "León",
    "310": "Tamaulipas",
    "311": "Aguascalientes",
    "312": "Guanajuato",
    "313": "Querétaro",
    "314": "San Luis Potosí",
    "315": "Zacatecas",
    "316": "Distrito Federal",
    "317": "México",
    "318": "Morelos",
    "319": "Colima",
    "320": "Jalisco",
    "321": "Michoacán",
    "322": "Nayarit",
    "323": "Hidalgo",
    "324": "Puebla",
    "325": "Tlaxcala",
    "326": "Veracruz",
    "327": "Campeche",
    "328": "Quintana Roo",
    "329": "Tabasco",
    "330": "Yucatán",
    "331": "Chiapas",
    "332": "Guerrero",
    "333": "Oaxaca",
    "334": "Columbia Británica",
    "335": "Alberta",
    "336": "Saskatchewan",
    "337": "Manitoba",
    "338": "Ontario",
    "339": "Quebec",
    "340": "New  Brunswick",
    "341": "Isla del Príncipe Eduardo",
    "342": "Nueva Escocia",
    "343": "Newfoundland y Labrador",
    "344": "Yukón",
    "345": "Noroeste",
    "346": "Territorios",
    "347": "Nunavut",
    "348": "Alabama",
    "349": "Alaska",
    "350": "Arizona",
    "351": "Arkansas",
    "352": "California",
    "353": "Colorado",
    "354": "Connecticut",
    "355": "Delaware",
    "356": "Florida",
    "357": "Georgia",
    "358": "Hawaii",
    "359": "Idaho",
    "360": "Illinois",
    "361": "Indiana",
    "362": "Iowa",
    "363": "Kansas",
    "364": "Kentucky",
    "365": "Louisiana",
    "366": "Maine",
    "367": "Maryland",
    "368": "Massachusetts",
    "369": "Michigan",
    "370": "Minnesota",
    "371": "Mississippi",
    "372": "Missouri",
    "373": "Montana",
    "374": "Nebraska",
    "375": "Nevada",
    "376": "New Hampshire",
    "377": "New Jersey",
    "378": "New Mexico",
    "379": "New York",
    "380": "Carolina del Norte",
    "381": "Norte",
    "382": "Dakota",
    "383": "Ohio",
    "384": "Oklahoma",
    "385": "Oregon",
    "386": "Pennsylvania",
    "387": "Rhode Island",
    "388": "Carolina del Sur",
    "389": "Dakota del Sur",
    "390": "Tennessee",
    "391": "Texas",
    "392": "Utah",
    "393": "Vermont",
    "394": "Virginia",
    "395": "Washington",
    "396": "West Virginia",
    "397": "Wisconsin",
    "398": "Wyoming",
    "399": "Abruzzo",
    "400": "Valle de Aosta",
    "401": "Apulia",
    "402": "Basilicata",
    "403": "Calabria",
    "404": "Campania",
    "405": "Emilia-Romagna",
    "406": "Friuli-Venezia Giulia",
    "407": "Lazio",
    "408": "Liguria",
    "409": "Lombardía",
    "410": "Marche",
    "411": "Molise",
    "412": "Piamonte",
    "413": "Cerdeña",
    "414": "Sicilia",
    "415": "Trentino-Alto Adigio/Südtirol",
    "416": "Toscana",
    "417": "Umbria",
    "418": "Veneto",
    "419": "Acre",
    "420": "Alagoas",
    "421": "Amapá",
    "422": "Amazonas",
    "423": "Bahia",
    "424": "Ceará",
    "425": "Distrito Federal",
    "426": "Espírito Santo",
    "427": "Goiás",
    "428": "Maranhão",
    "429": "Mato Grosso",
    "430": "Mato Grosso do Sul",
    "431": "Minas Gerais",
    "432": "Pará",
    "433": "Paraíba",
    "434": "Paraná",
    "435": "Pernambuco",
    "436": "Piauí",
    "437": "Rio de Janeiro",
    "438": "Rio Grande do Norte",
    "439": "Rio Grande do Sul",
    "440": "Rondônia",
    "441": "Roraima",
    "442": "Santa Catarina",
    "443": "São Paulo",
    "444": "Sergipe",
    "445": "Tocantins",
    "446": "Alsace-Champagne-Ardenne-Lorraine",
    "447": "Aquitaine-Limousin-Poitou-Charentes",
    "448": "Auvergne-Rhône-Alpes",
    "449": "Borgoña-Franco-Condado",
    "450": "Bretaña",
    "451": "Valle Central del Loira",
    "452": "Corsica",
    "453": "Isla de Francia",
    "454": "Languedoc-Roussillon-Midi-Pyrénées",
    "455": "Nord-Pas-de-Calais-Picardy",
    "456": "Normandía",
    "457": "Pays de la Loire",
    "458": "Provenza- Los Alpes del la Costa Azul",
    Territory: "Territory",
    Anhui: "Anhui",
    Beijing: "Beijing",
    "Chinese Taipei": "Chinese Taipei",
    "Chong Qing": "Chong Qing",
    Fujian: "Fujian",
    Gansu: "Gansu",
    Guangdong: "Guangdong",
    Guangxi: "Guangxi",
    Guizhou: "Guizhou",
    Hainan: "Hainan",
    Hebei: "Hebei",
    Heilongjiang: "Heilongjiang",
    Henan: "Henan",
    "Hong Kong": "Hong Kong",
    Hubei: "Hubei",
    Hunan: "Hunan",
    Jiangsu: "Jiangsu",
    Jiangxi: "Jiangxi",
    Jilin: "Jilin",
    Liaoning: "Liaoning",
    Macao: "Macao",
    "Nei Mongol": "Nei Mongol",
    Ningxia: "Ningxia",
    Qinghai: "Qinghai",
    Shaanxi: "Shaanxi",
    Shandong: "Shandong",
    Shanghai: "Shanghai",
    Shanxi: "Shanxi",
    Sichuan: "Sichuan",
    Tianjin: "Tianjin",
    Xinjiang: "Xinjiang",
    Xizang: "Xizang",
    Yunnan: "Yunnan",
    Zhejiang: "Zhejiang",
  },
};

export default countriesAndRegions;
